import { render } from "./TrainerCard.vue?vue&type=template&id=d98fef84&scoped=true"
import script from "./TrainerCard.vue?vue&type=script&lang=js"
export * from "./TrainerCard.vue?vue&type=script&lang=js"

import "./TrainerCard.vue?vue&type=style&index=0&id=d98fef84&lang=scss&scoped=true"

import exportComponent from "/home/misha/Рабочий стол/ucsa-system-front-admin/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d98fef84"]])

export default __exports__